// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.topic-list__button-create {
  float: left;
  margin: 1.5rem 4rem;
}

.topic-list__button-cancel-create {
  background-color: #d22e37;
  float: left;
  margin: 1.5rem 4rem;
  margin-left: -2rem;
}

.topic-list__container {
  height: calc(100vh - 6rem);
  display: flex;
  flex-direction: column;
  overflow: auto;
}

.topic-list__items {
  min-width: 60rem;
  margin: 0 1rem;
}

.w-md-editor-fullscreen {
  right: 8rem;
  left: 10rem;
}

.topics-list__id {
    cursor: pointer;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Chrome/Safari/Opera */
    -khtml-user-select: none; /* Konqueror */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently not supported by any browser */
    text-align: left;
}

.topic-table {
    margin-left: 20px;
    font-weight: bold;
}

    .topic-table th {
        padding-right: 50px;
    }`, "",{"version":3,"sources":["webpack://./src/app/nlp/topic-list/TopicList.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;IACI,eAAe;IACf,2BAA2B,EAAE,eAAe;IAC5C,yBAAyB,EAAE,wBAAwB;IACnD,wBAAwB,EAAE,cAAc;IACxC,sBAAsB,EAAE,YAAY;IACpC,qBAAqB,EAAE,2BAA2B;IAClD,iBAAiB,EAAE,iEAAiE;IACpF,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;IAEI;QACI,mBAAmB;IACvB","sourcesContent":[".topic-list__button-create {\r\n  float: left;\r\n  margin: 1.5rem 4rem;\r\n}\r\n\r\n.topic-list__button-cancel-create {\r\n  background-color: #d22e37;\r\n  float: left;\r\n  margin: 1.5rem 4rem;\r\n  margin-left: -2rem;\r\n}\r\n\r\n.topic-list__container {\r\n  height: calc(100vh - 6rem);\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: auto;\r\n}\r\n\r\n.topic-list__items {\r\n  min-width: 60rem;\r\n  margin: 0 1rem;\r\n}\r\n\r\n.w-md-editor-fullscreen {\r\n  right: 8rem;\r\n  left: 10rem;\r\n}\r\n\r\n.topics-list__id {\r\n    cursor: pointer;\r\n    -webkit-touch-callout: none; /* iOS Safari */\r\n    -webkit-user-select: none; /* Chrome/Safari/Opera */\r\n    -khtml-user-select: none; /* Konqueror */\r\n    -moz-user-select: none; /* Firefox */\r\n    -ms-user-select: none; /* Internet Explorer/Edge */\r\n    user-select: none; /* Non-prefixed version, currently not supported by any browser */\r\n    text-align: left;\r\n}\r\n\r\n.topic-table {\r\n    margin-left: 20px;\r\n    font-weight: bold;\r\n}\r\n\r\n    .topic-table th {\r\n        padding-right: 50px;\r\n    }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
